import Counter from 'src/internal/platformMetrics/aggregators/Counter';

export const safeParams = ['dashboard_banners'] as const;

type SafeParams = (typeof safeParams)[number];

export default new Counter<SafeParams>('frontend.platform-ui.banner-count');
